// extracted by mini-css-extract-plugin
export default {"DownloadButton":"DownloadButton_DownloadButton__qY0Rq"};